// extracted by mini-css-extract-plugin
export default {"container":"OrganizationLayout_container__mGplT","content":"OrganizationLayout_content__tctZz"};